import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { getFeaturedMovies, getLatestMovies, getMoviesByFlag } from "@/utils/movie";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntry from "@/pages/home/components/CategoryEntry";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import TopicSection from "@/pages/home/components/TopicSection";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  useDocumentTitle(
    "色色影院-最新电影电视剧免费在线观看平台",
    "色色影院为您提供海量电影、电视剧资源，覆盖多种类型。用户可轻松查找影视内容，享受优质的视频播放体验。",
  );

  const featured = getFeaturedMovies();
  const latest = getLatestMovies(6);
  const hot = getMoviesByFlag("isHot", 6);
  const classic = getMoviesByFlag("isClassic", 6);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroCarousel movies={featured} />
        <CategoryEntry />
        <FeaturedSection
          title="最新上映"
          subtitle="刚刚上线的电影与剧集，第一时间了解"
          movies={latest}
          moreTo="/category?sort=release"
        />
        <FeaturedSection
          title="热门推荐"
          subtitle="近期讨论度最高的影视作品"
          movies={hot}
          moreTo="/category?sort=hot"
          tone="tinted"
        />
        <FeaturedSection
          title="经典回顾"
          subtitle="经得起时间考验的口碑之作"
          movies={classic}
          moreTo="/category?sort=rating"
        />
        <TopicSection />
        <SiteIntro />
      </main>
      <Footer />
    </div>
  );
}